import getConfig from 'next/config'

const { publicRuntimeConfig } = getConfig()
const {
  CUSTOMERS_OVERVIEW_GRAPHQL_URI,
  CUSTOMER_OVERVIEW_V3_URI,
  SHOW_QUERY_DEBUG,
  NOVA_SDK_SRC,
  NOVA_SDK_API_URI,
  NOVA_SDK_INAPP_API_URI,
  NOVA_SDK_PUSH_SUBSCRIBE_URI,
  NOVA_SDK_CLICK_TRACKER_URI,
  APPLICATION_CODE,
  BASE_URI,
  WEB_URI,
  OAUTH_CLIENT_ID,
  OAUTH_SERVICE_URI,
  AUTH_SERVICE_URI,
  VISION_SERVICE_URI,
  TOURNAMENT_ENGINE_SERVICE_URI,
  MARKETING_SERVICE_URI,
  CLUSTERING_SERVICE_URI,
  NHUB_SERVICE_URI,
  NOVA_ENV,
  VERSION,
  UPLOAD_SERVICE_URI,
  SIMULATE_URI,
  SIMULATE_TOURNAMENT_URI,
  AUTH_FORM_URI,
  AUTHORIZATION_CODE_REDIRECT_URI,
  AUTHORIZATION_CODE_REDIRECT_URI_SILENT,
  WEBMANAGER_URI,
  SIMULATE_REPORT_URI,
  MIXPANEL_TOKEN,
  USER_PREFERENCES_URI,
  HR_BOT_BO_URI,
  AVATAR_STUDIO_URI,
  CUSTOMER_URI,
  TOGGLE_FEATURE_BO_URI,
  RECOMMENDATIONS_REPORT_URI,
  ELEVIO_ACCOUNT_ID,
  CAMPAIGN_BONUS_URI,
  UNLAYER_PROJECT_ID,
  BET9JA_PROD_ID,
  BET9JA_STG_ID,
  BET9JA_COUPONS_URI,
  YAJUEGO_PROD_ID,
  YAJUEGO_STG_ID,
  AUDIENCE_MANAGER_URI,
  TOGGLE_FEATURE_TOKEN,
  SENTRY_DSN_URI,
  BONUS_INTEGRATION_URI,
  CMS_BASE_URI,
  CASINO_ASSETS_UPLOADER_TOKEN,
  MKTOOL_ADAPTOR_URI,
  RELEASE_CHECK_URI,
  K8_BASE_URI,
  REPORT_URI,
  RESPONSIBLE_GAMBLING_URI,
  HASURA_GRAPHQL_URI,
  MOZZARTBET_STG_ID,
  MOZZARTBET_PROD_ID,
  MOZZARTBET_SERBIA_STG_ID,
  MOZZARTBET_SERBIA_PROD_ID,
  SOCCCERBET_SERBIA_STG_ID,
  SOCCCERBET_SERBIA_PROD_ID,
  TEAPUESTO_STG_ID,
  TEAPUESTO_PROD_ID,
  TEAPUESTO_PERU_PROD_ID,
  TEAPUESTO_PERU_STG_ID,
  GAME_ASSETS_URI,
  K8_DS_BASE_URI,
  ACTIVATION_SERVICE_URI,
  LANDING_PAGE_URI,
  GLI_CERTIFICATION_STG_ID,
  FRAUD_DETECTION_URI,
  SPIN_AND_WIN_PROD_ID,
  SPIN_AND_WIN_STG_ID,
  MAYBETS_KENYA_STG_ID,
  MAYBETS_KENYA_PROD_ID,
  MAMABET_STG_ID,
  MAMABET_PROD_ID,
  MOZZARTBET_CROATIA_STG_ID,
  MOZZARTBET_CROATIA_PROD_ID,
  GAMING_HUB_STG_ID,
  GAMING_HUB_PROD_ID,
  BET9JA_SHOP_APP_STG_ID,
  BET9JA_SHOP_APP_PROD_ID,
  ARISTOCRAT_ZIMBABWE_STG_ID,
  ARISTOCRAT_GABON_STG_ID,
  ARISTOCRAT_PREMIERBET_CAMEROON_PROD_ID,
  ARISTOCRAT_PREMIERBET_MALAWI_PROD_ID,
  ARISTOCRAT_PREMIERBET_UGANDA_PROD_ID,
  ARISTOCRAT_PREMIERBET_CONGO_PROD_ID,
  ARISTOCRAT_PREMIERBET_SIERRA_LEONE_PROD_ID,
  ARISTOCRAT_PREMIERBET_SENEGAL_PROD_ID,
  PREMIERBET_PROD_ID,
  ARISTOCRAT_PREMIERBET_CHAD_PROD_ID,
  ARISTOCRAT_PREMIERBET_MOZAMBIQUE_PROD_ID,
  ARISTOCRAT_PREMIERBET_MALI_PROD_ID,
  ARISTOCRAT_PREMIERBET_ANGOLA_PROD_ID,
  ARISTOCRAT_PREMIERBET_TANZANIA_PROD_ID,
  ARISTOCRAT_PREMIERBET_GUINEA_PROD_ID,
  ARISTOCRAT_PREMIERBET_LIBERIA_PROD_ID,
  ARISTOCRAT_PREMIERBET_ETHIOPIA_PROD_ID,
  ARISTOCRAT_PREMIERBET_IVORY_COAST_PROD_ID,
  ARISTOCRAT_PREMIERBET_NAMIBIA_PROD_ID,
  SMS_PROVIDER_URI,
  BET9JA_LIVE_CHAT_SERVICE_URI,
  BET9JA_AGENT_STG_ID,
  BET9JA_AGENT_PROD_ID,
  LIVE_CHAT_GRAFANA_URI,
  GAMING_HUB_SERVICE_URI,
} = publicRuntimeConfig

export default {
  google: {
    analyticsKey: 'UA-xxxxxxxxx-1',
  },
}

// eslint-disable-next-line import/no-mutable-exports
let version: string | null = 'local'
if (VERSION && VERSION.startsWith('refs/tags/')) {
  version = VERSION.slice(10)
}
if (VERSION && VERSION.startsWith('refs/heads/')) {
  version = VERSION.slice(11)
}

const baseUrl = BASE_URI || ''
const k8BaseUrl = K8_BASE_URI || ''
const k8DSBaseUrl = K8_DS_BASE_URI || ''

const webUri = WEB_URI || 'https://hub.novafutur.com'
const siteConfig = {
  siteName: 'NOVAFUTUR',
  siteIcon: 'ion-flash',
  dashboard: '/',
  footerText: `Powered by Novafutur ©${new Date().getFullYear()}. Version ${version}`,
}
const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault',
}
const showQueryDebug = SHOW_QUERY_DEBUG || false
const novaEnv = NOVA_ENV

const sdk = {
  sdkSrc: NOVA_SDK_SRC || 'https://nova-hub-dev.web.app/nova-sdk-snippet.js',
  applicationCode: APPLICATION_CODE || 'xxxx-xxxx',
  sdkApiUri:
    NOVA_SDK_API_URI ||
    'https://europe-west2-dev-mlviewer.cloudfunctions.net/api',
  inappMessagesUrl:
    NOVA_SDK_INAPP_API_URI ||
    'https://europe-west2-dev-mlviewer.cloudfunctions.net/api',
  pushSubscribeUri:
    NOVA_SDK_PUSH_SUBSCRIBE_URI ||
    'https://europe-west2-dev-mlviewer.cloudfunctions.net/api/subscribe',

  popupClickTrackerUrl:
    NOVA_SDK_CLICK_TRACKER_URI ||
    'https://hub.svcs.dev.futurfly.com/user-track/api',
}

const langDir = 'ltr'
const jwtConfig = {
  clientId: OAUTH_CLIENT_ID,
}
// get it from api directly just for now it here
const services = {
  oauth: OAUTH_SERVICE_URI || '/oauth',
  auth: AUTH_SERVICE_URI || '/auth/v1',
  vision: VISION_SERVICE_URI || '/vision/api/v1',
  // tournament-engine is a standalone service on its own host (not behind the
  // k8 gateway like vision), so this is a full base URL, not a gateway path.
  tournamentEngine:
    TOURNAMENT_ENGINE_SERVICE_URI ||
    'https://tournament-engine.svcs.stg.futurfly.com',
  nHub:
    NHUB_SERVICE_URI ||
    'https://notificationhub-dot-dev-267115.appspot.com/api/',
  upload: UPLOAD_SERVICE_URI || '/upload/v1',
  marketing: MARKETING_SERVICE_URI || '/marketing/api/v2',
  clustering: CLUSTERING_SERVICE_URI || '/clustering/v1',
  reporting: REPORT_URI || '/report/api/v1',
  simulate:
    SIMULATE_URI ||
    'https://simulate-api-node-dot-dev-simulate.appspot.com/api',
  simulateTournament:
    SIMULATE_TOURNAMENT_URI ||
    'https://simulate-multitenant-stg.svcs.stg.futurfly.com/reporting/coupons/api',
  simulateReports:
    SIMULATE_REPORT_URI ||
    'https://simulate-reports-dev-dot-dev-simulate.ew.r.appspot.com',
  userPreferences: USER_PREFERENCES_URI || '/userpref/api/v1',
  hrBotBo: HR_BOT_BO_URI || `${baseUrl}/hr-bot-bo`,
  // avatar-platform is a standalone service, not behind the k8 gateway, so this is a
  // full base URL. Locally it serves 5001 (3000 and 3010 are taken on a dev machine).
  avatarStudio: AVATAR_STUDIO_URI || 'http://localhost:5001',
  customers:
    CUSTOMER_URI || 'https://customer-overview-stg-k24le57fqa-ew.a.run.app/',
  customersV3:
    CUSTOMER_OVERVIEW_V3_URI ||
    'https://dl.svcs.dev.futurfly.com/customer-overview',
  toggleFeature: TOGGLE_FEATURE_BO_URI || `${baseUrl}/toggle-feature`,
  recommendationsReport:
    RECOMMENDATIONS_REPORT_URI ||
    'https://logispin.recommendations.stg.novafutur.com',
  campaignBonus: CAMPAIGN_BONUS_URI || 'https://campaigns.dl.dev.novafutur.com',
  audienceManager:
    AUDIENCE_MANAGER_URI || 'https://audience-manager.dl.dev.novafutur.com',
  bonusIntegration:
    BONUS_INTEGRATION_URI || 'https://bonus-integration.dev.futurfly.com',
  mktoolAdaptor:
    MKTOOL_ADAPTOR_URI || 'https://hub.svcs.dev.futurfly.com/mktool-adapter/v1',
  releaseCheck:
    RELEASE_CHECK_URI ||
    'https://hub.svcs.dev.futurfly.com/release-orchestrator/api',
  responsibleGambling:
    RESPONSIBLE_GAMBLING_URI ||
    'https://ds.svcs.dev.futurfly.com/responsible-gambling',

  fraudDetection:
    FRAUD_DETECTION_URI ||
    'https://ds.svcs.stg.futurfly.com/ml-fraud-detection',

  activation: ACTIVATION_SERVICE_URI || '/market-campaign-optimiser/v1',
  landingPage:
    LANDING_PAGE_URI ||
    ' https://hub.svcs.dev.futurfly.com/landing-pages-service/api/v1',
  smsProvider:
    SMS_PROVIDER_URI || 'https://hub.svcs.dev.futurfly.com/api/v3/setting',
  bet9jaLiveChatServiceUri:
    BET9JA_LIVE_CHAT_SERVICE_URI || 'https://stg-livechat.bet9ja.com',
  gamingHub: GAMING_HUB_SERVICE_URI || 'https://stg-gaminghub.logifuture.com',
  casinoAssetsUploader: CMS_BASE_URI || 'https://stg-cms.bet9ja.com',
  cms: CMS_BASE_URI || 'https://stg-cms.bet9ja.com',
  bet9jaCoupons: BET9JA_COUPONS_URI || 'https://stg-coupon.bet9ja.com',
}

const casinoAssetsUploaderToken = CASINO_ASSETS_UPLOADER_TOKEN || ''
const sentryDsn =
  SENTRY_DSN_URI ||
  'https://b8edcf1136074238afd0b9ff337d24fc@o1353005.ingest.sentry.io/6662282'

const toggleFeatureToken =
  TOGGLE_FEATURE_TOKEN ||
  '8a2b5a2bff3201a024d545aeb7af765855b8bf8615e2e198f3119c2156f3ff9a'

const customersOverviewGraphqlUri =
  CUSTOMERS_OVERVIEW_GRAPHQL_URI ||
  'https://dl.svcs.dev.futurfly.com/customers-overview/graphql/query'

const hasuraGraphqlUri =
  HASURA_GRAPHQL_URI || 'https://hub.svcs.dev.futurfly.com/hasura/v1/graphql'

const authenticationServerUri =
  AUTH_SERVICE_URI || 'https://auth.stg.novafutur.com/api/v1'
const authenticationFormUri =
  AUTH_FORM_URI || 'https://welcome.stg.novafutur.com'
const redirectUri = AUTHORIZATION_CODE_REDIRECT_URI
const redirectUriSilent = AUTHORIZATION_CODE_REDIRECT_URI_SILENT

const webManagerURI = WEBMANAGER_URI
const mixpanelToken = MIXPANEL_TOKEN
const elevioAccountId = ELEVIO_ACCOUNT_ID

const unlayerProjectId = UNLAYER_PROJECT_ID || 31140
const bet9jaProdId = BET9JA_PROD_ID || '2b40e08d-0820-49d4-aad5-63c7a4636ce2'
const bet9jaStgId = BET9JA_STG_ID || 'ee5c30fa-4a1b-4068-a012-a3b49d145563'
const yaJuegoProdId = YAJUEGO_PROD_ID || '6c6569d8-d83e-4e96-a297-24cda1f26180'
const yaJuegoStgId = YAJUEGO_STG_ID || '89b88ea6-9010-4c8e-b782-97934d8fcc1b'
const mozzartbetStgId =
  MOZZARTBET_STG_ID || '39097bd2-6077-4ac1-93e4-65f5be15d4bc'
const mozzartbetProdId =
  MOZZARTBET_PROD_ID || 'a71ec8cc-2375-4a19-b40d-0abbccf73b64'
const spinAndWinProdId =
  SPIN_AND_WIN_PROD_ID || '87f30c9a-a9dd-447e-af8b-d5cf4469e8b6'
const spinAndWinStgId =
  SPIN_AND_WIN_STG_ID || 'f3da72b8-7d9e-4776-96c6-06d80f351c16'

const mozzartbetSerbiaStgId =
  MOZZARTBET_SERBIA_STG_ID || '8e7ff376-7a13-4612-9971-e96be5374477'
const mozzartbetSerbiaProdId =
  MOZZARTBET_SERBIA_PROD_ID || 'not-setup-yet-MOZZARTBET_SERBIA'

const mozzartbetCroatiaStgId =
  MOZZARTBET_CROATIA_STG_ID || '26c8d4ec-34b4-4acb-a0b5-0939ad15a8d6'
const mozzartbetCroatiaProdId =
  MOZZARTBET_CROATIA_PROD_ID || 'c5b49b16-b615-48cf-87af-cf8950aa472f'

const soccerbetSerbiaStgId =
  SOCCCERBET_SERBIA_STG_ID || '461ca2bc-f5e2-45ce-996b-00fbaaec5389'
const soccerbetSerbiaProdId =
  SOCCCERBET_SERBIA_PROD_ID || 'c122ac3b-d1aa-4ac3-a394-27b80f143c0b'

const gameAssetsUrlEnvVar =
  GAME_ASSETS_URI || 'https://game-assets.stg.hub.novafutur.com'
const gliCertificationStgId =
  GLI_CERTIFICATION_STG_ID || '2d03a7a6-c63c-4668-b179-26a329db60b2'

const teapuestoStgId =
  TEAPUESTO_STG_ID || '7256d029-b659-43ae-8451-e75b9531df3d'
const teapuestoProdId =
  TEAPUESTO_PROD_ID || '619cc257-9881-4edd-b379-439e27ce0a3d'
const teapuestoPeruProdId =
  TEAPUESTO_PERU_PROD_ID || '58801c29-6e34-4b05-9ff1-741d3491a11c'
const teapuestoPeruStgId =
  TEAPUESTO_PERU_STG_ID || '06af9ac6-3127-11ee-be56-0242ac120002'

const maybetsKenyaStgId =
  MAYBETS_KENYA_STG_ID || 'aca6bf2b-bbde-4522-846d-65fd8c08ff8e'
const maybetsKenyaProdId =
  MAYBETS_KENYA_PROD_ID || '8658b1e0-4293-4ba3-9057-60ac035cb603'

const mamabetStgId = MAMABET_STG_ID || '73bda96e-698a-4a43-8697-44634d0eccfe'
const mamabetProdId = MAMABET_PROD_ID || 'a6cfc664-d015-4508-b43e-c612fd84a6fc'
const aristocratZimbabweStgId =
  ARISTOCRAT_ZIMBABWE_STG_ID || 'cda24b59-7259-41cb-9dd3-ec8425ff921c'
const aristocratGabonStgId =
  ARISTOCRAT_GABON_STG_ID || 'cda24b59-7259-41cb-9dd3-ec8425ff921c'

const aristocratPremierbetCameroonProdId =
  ARISTOCRAT_PREMIERBET_CAMEROON_PROD_ID ||
  '4b78fec1-07dc-4b2a-9775-8eba06f0aaea'
const aristocratPremierbetMalawiProdId =
  ARISTOCRAT_PREMIERBET_MALAWI_PROD_ID || '2691162b-2a56-4062-9a4a-8cab1b6d60dc'
const aristocratPremierbetUgandaProdId =
  ARISTOCRAT_PREMIERBET_UGANDA_PROD_ID || '134be2c0-c406-4e7e-89a4-1edcf3b020c1'
const aristocratPremierbetCongoProdId =
  ARISTOCRAT_PREMIERBET_CONGO_PROD_ID || 'fe4121bb-eb02-430c-8778-368b88582c53'
const aristocratPremierbetSierraLeoneProdId =
  ARISTOCRAT_PREMIERBET_SIERRA_LEONE_PROD_ID ||
  '39df34ef-3db5-460c-a286-84077e5fdabf'
const aristocratPremierbetSenegalProdId =
  ARISTOCRAT_PREMIERBET_SENEGAL_PROD_ID ||
  '4df69ffe-d9bc-4005-a231-11df7bd6314b'
const premierbetProdId =
  PREMIERBET_PROD_ID || '02c8aef7-52ae-4f16-8439-336f6b924a5c'
const aristocratPremierbetChadProdId =
  ARISTOCRAT_PREMIERBET_CHAD_PROD_ID || '46332202-757c-40ca-8682-cf3d34497d41'
const aristocratPremierbetMozambiqueProdId =
  ARISTOCRAT_PREMIERBET_MOZAMBIQUE_PROD_ID ||
  'dc3025a4-ee29-4ee7-b589-9e654d95972b'
const aristocratPremierbetMaliProdId =
  ARISTOCRAT_PREMIERBET_MALI_PROD_ID || 'af792ad8-a126-4d82-acbd-240405c7c283'
const aristocratPremierbetAngolaProdId =
  ARISTOCRAT_PREMIERBET_ANGOLA_PROD_ID || 'e487b42f-4d73-4508-81df-bb597a4e4880'
const aristocratPremierbetTanzaniaProdId =
  ARISTOCRAT_PREMIERBET_TANZANIA_PROD_ID ||
  '9a2a7bb8-7ed0-4074-a7aa-ac22733347c2'
const aristocratPremierbetGuineaProdId =
  ARISTOCRAT_PREMIERBET_GUINEA_PROD_ID || '9f0214a4-5569-4738-a4ba-0a96e1ccf6a5'
const aristocratPremierbetLiberiaProdId =
  ARISTOCRAT_PREMIERBET_LIBERIA_PROD_ID ||
  '694dfb34-d871-4ad2-b5d1-fbe92cf723a7'
const aristocratPremierbetEthiopiaProdId =
  ARISTOCRAT_PREMIERBET_ETHIOPIA_PROD_ID ||
  '9ad28b9e-73f8-4c3b-a3c9-50e11858fc7f'
const aristocratPremierbetIvoryCoastProdId =
  ARISTOCRAT_PREMIERBET_IVORY_COAST_PROD_ID ||
  'be7f6442-88cc-4607-985b-bcf7be6db6e6'
const aristocratPremierbetNamibiaProdId =
  ARISTOCRAT_PREMIERBET_NAMIBIA_PROD_ID ||
  'dbe491db-7093-4eb9-b830-3518cc8d0940'

const gamingHubStgId =
  GAMING_HUB_STG_ID || 'ac9c2a93-97ac-4266-98aa-f59730c747c5'
const gamingHubProdId =
  GAMING_HUB_PROD_ID || '19d34fac-783a-4f5d-886c-11d5b33d68d2'
const bet9jaShopAppStgId =
  BET9JA_SHOP_APP_STG_ID || '7177e90d-ecfe-4078-a96e-2db3216fdea4'
const bet9jaShopAppProdId =
  BET9JA_SHOP_APP_PROD_ID || '7b428e0c-b7b0-4c0c-ba22-7d887b9bc3e2'

const bet9jaLiveChatServiceUri =
  process.env.BET9JA_LIVE_CHAT_SERVICE_URI || 'https://stg-livechat.bet9ja.com'

const liveChatGrafanaUri =
  LIVE_CHAT_GRAFANA_URI ||
  'https://grafananonprod-am6.ags.gwsrv.com/d/livechat-service/livechat-service'
const bet9jaAgentStgId =
  BET9JA_AGENT_STG_ID || '8985c0fd-a24c-47af-b9bb-993d4fd57e85'
const bet9jaAgentProdId =
  BET9JA_AGENT_PROD_ID || '011a0b27-1267-4013-b029-e842bb5a9a8a'

export {
  aristocratGabonStgId,
  aristocratPremierbetAngolaProdId,
  aristocratPremierbetCameroonProdId,
  aristocratPremierbetChadProdId,
  aristocratPremierbetCongoProdId,
  aristocratPremierbetEthiopiaProdId,
  aristocratPremierbetGuineaProdId,
  aristocratPremierbetIvoryCoastProdId,
  aristocratPremierbetLiberiaProdId,
  aristocratPremierbetMalawiProdId,
  aristocratPremierbetMaliProdId,
  aristocratPremierbetMozambiqueProdId,
  aristocratPremierbetNamibiaProdId,
  aristocratPremierbetSenegalProdId,
  aristocratPremierbetSierraLeoneProdId,
  aristocratPremierbetTanzaniaProdId,
  aristocratPremierbetUgandaProdId,
  aristocratZimbabweStgId,
  authenticationFormUri,
  authenticationServerUri,
  baseUrl,
  bet9jaAgentStgId,
  bet9jaAgentProdId,
  bet9jaLiveChatServiceUri,
  bet9jaProdId,
  bet9jaShopAppProdId,
  bet9jaShopAppStgId,
  bet9jaStgId,
  casinoAssetsUploaderToken,
  customersOverviewGraphqlUri,
  elevioAccountId,
  gameAssetsUrlEnvVar,
  gamingHubProdId,
  gamingHubStgId,
  gliCertificationStgId,
  hasuraGraphqlUri,
  jwtConfig,
  k8BaseUrl,
  k8DSBaseUrl,
  langDir,
  liveChatGrafanaUri,
  mamabetProdId,
  mamabetStgId,
  maybetsKenyaProdId,
  maybetsKenyaStgId,
  mixpanelToken,
  mozzartbetCroatiaProdId,
  mozzartbetCroatiaStgId,
  mozzartbetProdId,
  mozzartbetSerbiaProdId,
  mozzartbetSerbiaStgId,
  mozzartbetStgId,
  novaEnv,
  premierbetProdId,
  redirectUri,
  redirectUriSilent,
  sdk,
  sentryDsn,
  services,
  showQueryDebug,
  siteConfig,
  soccerbetSerbiaProdId,
  soccerbetSerbiaStgId,
  spinAndWinProdId,
  spinAndWinStgId,
  teapuestoPeruProdId,
  teapuestoPeruStgId,
  teapuestoProdId,
  teapuestoStgId,
  themeConfig,
  toggleFeatureToken,
  unlayerProjectId,
  version,
  webManagerURI,
  webUri,
  yaJuegoProdId,
  yaJuegoStgId,
}
